const styles = {
  wrapper: {
    height: 60,
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '0 auto',
    backgroundColor: '#FFF',
  },
  title: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#476166',
  },
  children: {
    flex: 1,
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'center',
    alignItems: 'center',
  },
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/TopBar/TopBar.styles.js